import { Auth0Region } from '@auth/types';
import { Auth0ProviderOptions } from '@auth0/auth0-react';

import { authEnv } from '../parseEnv';

type Auth0RegionOptions = Pick<Auth0ProviderOptions, 'clientId' | 'domain' | 'audience'>;

export const getAuth0ConfigForRegion = (region: Auth0Region): Auth0RegionOptions => {
  switch (region) {
    case Auth0Region.EU:
      return {
        clientId: authEnv.VITE_AUTH0_EU_CLIENT_ID,
        domain: authEnv.VITE_AUTH0_EU_DOMAIN,
        audience: authEnv.VITE_WEBAPI_AUTH0_EU_AUDIENCE,
      };
    case Auth0Region.US:
      return {
        clientId: authEnv.VITE_AUTH0_US_CLIENT_ID,
        domain: authEnv.VITE_AUTH0_US_DOMAIN,
        audience: authEnv.VITE_WEBAPI_AUTH0_US_AUDIENCE,
      };
  }
};
